<template>
  <div class="files">
    <Head title="Besucheranmeldung" />

    <div class="col-two">
      <div class="col-two--left">



       <textblock :textblocks="textblocks" :auth="auth" :textid="2"></textblock>





        <form class="visitors"  @submit.prevent="onSubmit" >
          <div>
            <div class="formrow">
              <label>Firma *</label>
              <input type="text" v-model="data.company" required>
            </div>
            <div class="formrow">
              <label>Kontakt für Besucherankündigung *</label>
              <input type="text" v-model="data.contact_firstname" required>
              <div class="input-caption">Vorname</div>
              <input type="text" v-model="data.contact_lastname" required>
              <div class="input-caption">Nachname</div>
            </div>
            <div class="formrow">
              <label>E-mail *</label>
              <input type="text" v-model="data.email" required>
            </div>
            <div class="formrow">
              <label>Telefon *</label>
              <input type="text" v-model="data.phone" required>
            </div>
            <div class="formrow">
              <label>Bemerkungen</label>
              <textarea v-model="data.remarks"></textarea>
            </div>
            <div class="formrow">
              <input class="btn" type="submit" value="Anmelden" />
            </div>
          </div>
          <div>
            <div class="formrow">
              <label>Stockwerk *</label>
              <select type="text" v-model="data.floor">
                  <option value="EG">EG</option>
                  <option value="Zwischengeschoss">Zwischengeschoss</option>
                  <option :value="n + '. OG'" v-for="n in floors">{{ n }}. OG</option>
              </select>
            </div>
            <div class="formrow">
              <label>Datum des Besuchs *</label>
              <Datepicker v-model="data.date" locale="de" autoApply :enableTimePicker="false"  format="dd.MM.yyyy" />
           </div>
           <div class="formrow">
               <label>Zeit *</label>
               <input type="text" v-model="data.time_start" placeholder="10:00" required>
            </div>

            <div class="formrow">
              <label>Besucher-Name *</label>
              <input type="text" v-model="data.visitor_firstname" required>
              <div class="input-caption">Vorname</div>
              <input type="text" v-model="data.visitor_lastname" required>
              <div class="input-caption">Nachname</div>
            </div>

          </div>

        </form>



      </div>
      <div class="col-two--right">
          <div class="weather">
            <a class="weatherwidget-io" href="https://forecast7.com/de/47d508d72/winterthur/" data-label_1="WINTERTHUR" data-label_2="Wetter" data-font="Open Sans" data-days="3" data-theme="pure" >WINTERTHUR Wetter</a>
          </div>
          <div class="today"><span><label>{{ weekday }}</label><i>{{ date }}</i></span></div>
          <div class="calendar-teaser">
            <vue-cal
              ref="vuecal"
              locale="de"
              hide-view-selector
              :disable-views="['years', 'year', 'year','week','day']"
              active-view="month"
              :time-from="7 * 60" :time-to="22 * 60"
              :events="events"
              :on-event-click="onEventClick">
            </vue-cal>
          </div>
      </div>
    </div>



  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import { useForm } from '@inertiajs/inertia-vue3'

import Textblock from '@/Shared/Textblock'


import VueCal from 'vue-cal'
import 'vue-cal/dist/i18n/de.js'
import 'vue-cal/dist/vuecal.css'

import $ from "jquery";
import Datepicker from 'vue3-date-time-picker';
import 'vue3-date-time-picker/dist/main.css';

!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0];if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src='https://weatherwidget.io/js/widget.min.js';fjs.parentNode.insertBefore(js,fjs);}}(document,'script','weatherwidget-io-js');


export default {
  components: {
    Head,
    useForm,
    Datepicker,
    VueCal,
    Textblock,
    $
  },
  layout: Layout,
  data: function () {
    return {
      data: {
        company: '',
        contact_firstname: '',
        contact_lastname: '',
        email: '',
        phone: '',
        floor: 'EG',
        date: '',
        time_start: '',
        time_end: '',
        visitor_firstname: '',
        visitor_lastname: '',
        remarks: '',

      },

      floors: 26,
      date: null,
      weekday: null
    }
  },
  props: {
    auth: Object,
    textblocks: Object,
  },



   mounted() {
    this.$parent.bgimage = "/img/tower4.jpg";
    let app = this;
    let weekdays = ["Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag","Sonntag"];
    const today = new Date();
    const day = today.getDay();
    app.date = today.getDate();
    app.weekday = weekdays[day];

    setTimeout(function() {
       app.textblock = app.textblocks.find(x => x.id === 2);
    }, 5);



  },

  methods: {
    onSubmit(){
      let app = this;
      let formdat = this.$inertia.form(app.data);
      formdat.put('/visits',{
        onSuccess: page => {
           this.data.company = '',
           this.data.contact_firstname = '',
           this.data.contact_lastname = '',
           this.data.email = '',
           this.data.phone = '',
           this.data.floor = 'EG',
           this.data.date = '',
           this.data.time_start = '',
           this.data.time_end = '',
           this.data.visitor_firstname = '',
           this.data.visitor_lastname = '',
           this.data.remarks = ''
        },
      })
    },


  }


}
</script>
